import React, {useEffect} from 'react';
import QRCode from 'react-qr-code';
import {isDesktop} from 'react-device-detect';
import {redirectToAppOrDownload} from 'utils';
import {abnkLogo, frameAbnk} from 'assets';

const DEFAULT_QR_LINK = `https://${window.location.host}/appstore/`;

interface IDefaultProps {}

const Default: React.FC<IDefaultProps> = () => {
  useEffect(() => {
    if (!isDesktop || navigator.userAgent.includes('iPad') || /Android.*Mobile|Android.*Tablet/i.test(navigator.userAgent)) {
      redirectToAppOrDownload();
    }
  }, []);

  if (!isDesktop) return null;

  return (
    <main className="h-screen bg-green-600 flex flex-col lg:flex-row justify-center lg:justify-between items-center relative overflow-hidden">
      <div className="z-10 px-6 sm:px-10 md:pl-[5%] md:pr-10 pt-10 lg:pt-0 text-center lg:text-left">
        <h1 className="text-white text-5xl sm:text-5xl md:text-[56px] lg:text-[64px] font-medium font-inter-tight mt-10 lg:mt-28">
          Shop smarter
        </h1>
        <h1 className="text-white text-4xl sm:text-5xl md:text-[56px] lg:text-[64px] font-medium mb-4 sm:mb-6 font-inter-tight mt-5">
          with ABNK
        </h1>
        <p className="text-white text-base sm:text-lg lg:text-xl max-w-xs sm:max-w-md lg:max-w-xl mb-8 sm:mb-12 mx-auto lg:mx-0 lg:w-[90%] font-poppins">
          Track your spending, unlock exclusive rewards, and enjoy flexible payments—all in one
          place.
        </p>

        <div className="border-[1px] border-white backdrop-blur-sm px-4 sm:px-6 py-3 sm:py-4 rounded-2xl flex flex-col sm:flex-row items-center gap-4 sm:gap-6 w-fit max-w-xs sm:max-w-none mx-auto lg:mx-0">
          <div className="relative p-2 sm:p-4 bg-white rounded-xl">
            <QRCode value={DEFAULT_QR_LINK} size={120} className="sm:hidden" bgColor="#FFFFFF" fgColor="#000000" />
            <QRCode value={DEFAULT_QR_LINK} size={160} className="hidden sm:block" bgColor="#FFFFFF" fgColor="#000000" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-green-600 flex items-center justify-center">
                <img src={abnkLogo} alt="ABNK" className="w-8 h-8 sm:w-10 sm:h-10" />
              </div>
            </div>
          </div>
          <p className="text-white text-[0.9rem] sm:text-[1.1rem] font-poppins sm:mr-4 lg:mr-14 sm:ml-2 lg:ml-5 text-center sm:text-left">
            Scan to download
            <br />
            ABNK App
          </p>
        </div>
      </div>
      <div className="absolute bottom-0 right-0 z-0 flex justify-center lg:justify-end">
        <img
          alt="ABNK App Preview"
          src={frameAbnk}
          className="h-full w-[50%] object-contain lg:pr-10 opacity-20 lg:opacity-100"
        />
      </div>
    </main>
  );
};

export default Default;
